export const focusAndScrollToError = () => {
	setTimeout(() => {
		const inputWithError = document.querySelector('.input-error');
		if (inputWithError) {
			inputWithError.focus();
			inputWithError.scrollIntoView();
		}
	}, 1);
};
